import Vue from 'vue'
import Vuex from 'vuex'

// modules.
import auth from './auth'
import menu from './menu'
import ui from './ui'

Vue.use(Vuex)

export default new Vuex.Store({

  modules: {
    auth,
    menu,
    ui
  },

  state: {
    packageVersion: process.env.PACKAGE_VERSION || '0'
  },

  mutations: {},

  actions: {},

  getters : {
    
    appVersion: (state) => {
      return state.packageVersion
    },
    
  }
})